class Store {
    constructor() {
        this.pages = new Map();
        this.activeobjectid = "";
        this.activefileid = "";
    }
}
export const PdfPageStore = new Store();
export const FloatingPdfPageStore = new Store();
